import { useEnrollmentAccess } from "../access/useEnrollmentAccess";

export function useCourseStatus(courseId?: string) {
  const { canAccessLessons, canAccessCommunity, isAdmin } = useEnrollmentAccess(courseId ?? "");

  return {
    canAccessLessons,
    canAccessCommunity,
    isAdmin,
  };
}
